import React, { ReactNode } from "react"

interface TooltipProps {
    message: ReactNode
    children: ReactNode
}

export const Tooltip = ({ message, children }: TooltipProps) => {
    return (
        <div className="group relative inline-block">
            {children}
            <div
                className="absolute top-full left-1/2 -translate-x-1/2 mt-2 hidden group-hover:block whitespace-nowrap z-50 border border-gray-700 bg-gray-900 text-gray-50 rounded-lg py-1 px-2"
                role="tooltip"
            >
                {/* Top arrow */}
                <div className="absolute -top-[5px] left-1/2 -translate-x-1/2 w-2.5 h-2.5 rotate-45 border-t border-l border-gray-700 bg-gray-900" />

                <span className="relative z-10">{message}</span>
            </div>
        </div>
    )
}
